import i18next from "i18next";
import { GridToolbarContainer } from "@mui/x-data-grid-pro";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { PublishedWithChanges as PublishedWithChangesIcon } from "@mui/icons-material";

export const FixturesToolbar = ({
  mode,
  handleModeChange,
  forceCompile,
  setSelectionModel,
  setForceCompile,
}) => {
  return (
    <GridToolbarContainer sx={{ gap: 1, alignItems: "center" }}>
      <Typography variant="caption" sx={{ fontWeight: 800 }}>
        {i18next.t("help.compilePreview.modeLabel")}
      </Typography>
      <ToggleButtonGroup
        color="primary"
        value={mode}
        exclusive
        onChange={handleModeChange}
      >
        <ToggleButton
          value="compile"
          title={i18next.t("help.tooltips.compilationMode")}
        >
          {i18next.t("help.compilePreview.compileMode")}
        </ToggleButton>
        <ToggleButton
          value="evaluate"
          title={i18next.t("help.tooltips.evaluationMode")}
        >
          {i18next.t("help.compilePreview.evaluateMode")}
        </ToggleButton>
      </ToggleButtonGroup>
      {mode === "compile" && (
        <Box sx={{ ml: 0.5 }}>
          <ToggleButton
            size="small"
            value="check"
            selected={forceCompile}
            title={i18next.t("help.compilePreview.forceCompile")}
            onChange={() => {
              setSelectionModel([]);
              setForceCompile(!forceCompile);
            }}
          >
            <PublishedWithChangesIcon />
          </ToggleButton>
        </Box>
      )}
    </GridToolbarContainer>
  );
};
